import {RootState} from "../store/store";

export const selectCategories = (state: RootState) => state.categories.data;
export const selectCategoryStatus = (state: RootState) => state.categories.status;